<script>
    import { alert } from "../store";
    import {
        DataTable,
        Toolbar,
        ToolbarContent,
        OverflowMenu,
        OverflowMenuItem,
        Button,
        Modal,
        Form,
        FormGroup,
        TextInput,
        ToolbarBatchActions,
    } from "carbon-components-svelte";
    import TrashCan16 from "carbon-icons-svelte/lib/TrashCan16";
    import DocumentAdd20 from "carbon-icons-svelte/lib/DocumentAdd20";
    import {contexts, Contextsvc} from "../services/context";

    let contextsvc = new Contextsvc();
    let selectedRowIds = [];
    let confirmDelete = false;
    let opencontextmodal = false;
    let newContextName = "New context";
    let updateContext = {name: ""};    
    let updatecontextmodal = false;

    function update() {
        try {
        contextsvc.update([updateContext])
        updatecontextmodal = false;
        } catch (e) {
            console.log("Error updating context");
            console.log(e);
            alert.update((n) => [...n, "Failed to remove context " + e.message]);
            updatecontextmodal = false;            
        }
    }
    function remove() {
        try {
            let toBeDeleted = [];
            selectedRowIds.forEach((item) => {
                for (var i = 0; i < $contexts.length; i++) {
                    if ($contexts[i].id == item) {
                        $contexts[i].active = false;
                        toBeDeleted.push($contexts[i])
                        console.log("deleteContext: " + $contexts[i]);
                    }
                }
            });
            contextsvc.update(toBeDeleted);
        } catch (e) {
            //alert(e.message);
            console.log("Error removing context");
            console.log(e);
            alert.update((n) => [...n, "Failed to remove context " + e.message]);
            confirmDelete = false;
        }
        selectedRowIds = [];
        confirmDelete = false;
    }
    function createContext() {
        const data = {
            name: newContextName,
            active: true
        }
        try {
            contextsvc.add(data);
            console.log("Added context " + data.name);
        } catch (e) {
            //alert(e.message);
            console.log(e);
            alert.update((n) => [
                ...n,
                "Failed to add context " +
                    data.name +
                    " to context " +
                    e.message,
            ]);
        }
        console.log("createContext: reset");
        newContextName = "";
        opencontextmodal = false;

}

</script>

<DataTable
    sortable
    selectable bind:selectedRowIds
    title="Contexts"
    description="A context is a frame of mind or location that you work on similar tasks.  Tasks might share some property such as they must be done in the same location (Office for example) or perhaps they all share a requirement like 'Internet connection' :"
    headers={[
        { key: 'name', value: 'Name' }, 
        { key: 'description', value: 'Description' },
        { key: 'overflow', empty: true},
    ]}
    id="ContextsTable"
    rows={$contexts}
>
    <Toolbar>
        <ToolbarBatchActions>
            <Button icon={TrashCan16} on:click={() => (confirmDelete = true)}
                >Delete</Button
            >
        </ToolbarBatchActions>
        <ToolbarContent>
            <Button
                icon={DocumentAdd20}
                aria-label="Create Context"
                on:click={() => (opencontextmodal = true)}>Add Context</Button
            >
        </ToolbarContent>
    </Toolbar>
    <svelte:fragment slot="cell" let:cell let:row>
        {#if cell.key === "overflow"}
            <OverflowMenu flipped>
                <OverflowMenuItem 
                    text="Edit" 
                    id="edit"
                    on:click={() => {
                        updateContext = row;
                        newContextName = row.name;
                        updatecontextmodal = true;
                    }}
                />
                <OverflowMenuItem
                    danger
                    id="delete"
                    text="Delete"
                    on:click={() => {
                        selectedRowIds.push(row.id);
                        confirmDelete = true;
                    }}
                />
            </OverflowMenu>
        {:else}{cell.value}{/if}
    </svelte:fragment>
</DataTable>

<Modal
    bind:open={confirmDelete}
    modalHeading="Delete Context"
    primaryButtonText="Confirm"
    secondaryButtonText="Cancel"
    on:click:button--secondary={() => (confirmDelete = false)}
    on:open
    on:close
    on:submit={remove}
>
    <p>Delete these context(s).</p>
    <ul>
        {#each $contexts as row}
            {#each selectedRowIds as x}
                    {#if row.id == x}
                        <li>{row.name}</li>
                    {/if}
            {/each}
        {/each}
    </ul>
</Modal>

<Modal
    bind:open={opencontextmodal}
    modalHeading="Add Context"
    primaryButtonText="Submit"
    secondaryButtonText="Cancel"
    on:click:button--secondary={() => (opencontextmodal = false)}
    on:open
    on:close
    on:submit={createContext}
>
    <Form on:submit>
        <FormGroup legendText="Add a context">
            <TextInput
                id="contextInput"
                labelText="Context"
                bind:value={newContextName}
            />
        </FormGroup>
    </Form>
</Modal>

<Modal
    bind:open={updatecontextmodal}
    modalHeading="Update Context"
    primaryButtonText="Submit"
    secondaryButtonText="Cancel"
    on:click:button--secondary={() => (updatecontextmodal = false)}
    on:open
    on:close
    on:submit={update}
>
    <Form on:submit>
        <FormGroup legendText="Update a context">
            <TextInput
                id="contextupdateInput"
                labelText="Context"
                bind:value={updateContext.name}
            />
        </FormGroup>
    </Form>
</Modal>